import { DS_IMAGE_FILE_PREVIEW_EXTENSIONS } from "@/src/design_system/shared/constants/fileTypeIcons";

export const fileExtension = (fileName: string): string | undefined => {
  const separatorIndex = fileName.lastIndexOf(".");
  if (separatorIndex <= 0 || separatorIndex === fileName.length - 1) return undefined;

  return fileName.slice(separatorIndex + 1).toLowerCase();
};

export const isPreviewableImage = (fileName: string): boolean => {
  const extension = fileExtension(fileName);

  return DS_IMAGE_FILE_PREVIEW_EXTENSIONS.some(previewExtension => previewExtension === extension);
};
